import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { useI18n } from 'hooks/useI18n';
import { UIOfferTeamSection } from 'interfaces/ui/ui-offer-team-section';
import { useContext } from 'react';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import TeamMembers from './TeamMembers';
import TeamPicture from './TeamPicture';
import { StyledTeamSection } from './TeamSection.styled';

const TeamSection = ({
  teamImage,
  teamImageCaption,
  teamInfo,
  membersInfo,
  members,
  migratedToMarkdown,
  isFreelance
}: UIOfferTeamSection) => {
  const { t } = useI18n('job-offer');
  const showWIPFeatures = useContext(WIPFeaturesContext);

  return (
    <JobOfferSection
      name="equipo"
      sectionBg="alt"
      title={t(isFreelance ? 'titles.team_freelance' : 'titles.team')}
    >
      <StyledTeamSection>
        {showWIPFeatures && (
          <TeamPicture
            teamImage={teamImage}
            teamImageCaption={teamImageCaption}
          />
        )}
        <JobOfferLongText isMarkdown={migratedToMarkdown}>
          {teamInfo}
        </JobOfferLongText>
      </StyledTeamSection>

      {showWIPFeatures && (
        <TeamMembers
          membersInfo={membersInfo}
          members={members}
          migratedToMarkdown={migratedToMarkdown}
        />
      )}
    </JobOfferSection>
  );
};

export default TeamSection;
